import Vue from 'vue'
import tips from './index.vue'
let TipsConstructor = Vue.extend(tips)
let theTips = function (text, bool) {
  return new Promise((resolve, reject) => {
    let TipsDom = new TipsConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(TipsDom.$el)
    TipsDom.msg = text
    TipsDom.state = bool
  })
}
export default theTips

// 在需要的地方直接用以下方法调用即可：
// this.$tip(text, bool).then(() => {
//     console.log('ok')
// })
// .catch(() => {
// })



// WEBPACK FOOTER //
// ./src/common/tip/index.js